import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-icon-delivery-default",
  "use": "icon-icon-delivery-default-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol viewBox=\"0 0 24 24\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-icon-delivery-default\">\n    <title>icons/icon-delivery-default</title>\n    <g id=\"icon-icon-delivery-default_icons/icon-delivery-default\" stroke=\"none\" stroke-width=\"1\" fill=\"none\" fill-rule=\"evenodd\">\n        <circle id=\"icon-icon-delivery-default_Oval-Copy\" fill=\"#94A1AF\" cx=\"12\" cy=\"12\" r=\"4\" />\n    </g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol